/* eslint-disable no-undef */
/**
 * Original source: Platform/platform_project/theme/src/js/utils/csrf.js
 */
import jscookie from 'js-cookie';

// Order is important with this string, don't rearrange it. Has to match what Python generates.
const TOKEN_ALLOWED_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const TOKEN_LENGTH = 32;

/*
Much of the code below is translated from Django's CSRF token generation routines.
The original implementation referenced is here:
https://github.com/django/django/blob/stable/1.11.x/django/middleware/csrf.py
*/
function generateUnsaltedToken() {
  const allowedCharactersLength = TOKEN_ALLOWED_CHARS.length;
  let token = '';

  for (let i = 0; i < TOKEN_LENGTH; i++) {
    token += TOKEN_ALLOWED_CHARS.charAt(Math.floor(Math.random() * allowedCharactersLength));
  }

  return token;
}

export function extractCSRFSecret(ciphertext) {
  /*
  Given a CSRF token or cookie, decrypt and return the secret.
  Translated from Django's CSRF middleware.
  */
  const salt = ciphertext.slice(0, TOKEN_LENGTH);
  const token = ciphertext.slice(TOKEN_LENGTH);

  const indices = [];

  for (let i = 0; i < TOKEN_LENGTH; i++) {
    let index = TOKEN_ALLOWED_CHARS.indexOf(token[i]) - TOKEN_ALLOWED_CHARS.indexOf(salt[i]);
    if (index < 0) {
      index += TOKEN_ALLOWED_CHARS.length;
    }
    indices.push(index);
  }

  let secret = '';

  for (const index of indices) {
    secret += TOKEN_ALLOWED_CHARS[index];
  }

  return secret;
}

export function generateNewCSRFToken(from) {
  const allowedCharactersLength = TOKEN_ALLOWED_CHARS.length;
  let secret;
  if (from) {
    secret = extractCSRFSecret(from);
  } else {
    secret = generateUnsaltedToken();
  }
  const salt = generateUnsaltedToken();

  let token = '';
  for (let i = 0; i < TOKEN_LENGTH; i++) {
    const index =
      (TOKEN_ALLOWED_CHARS.indexOf(secret[i]) + TOKEN_ALLOWED_CHARS.indexOf(salt[i])) %
      allowedCharactersLength;
    token += TOKEN_ALLOWED_CHARS[index];
  }

  return salt + token;
}

export function CSRFTokenIsStale(ciphertext) {
  const currentCookie = jscookie.get('csrftoken');
  if (currentCookie === undefined) {
    return true;
  }

  const cookieSecret = extractCSRFSecret(currentCookie);
  const renderedSecret = extractCSRFSecret(ciphertext);

  return renderedSecret !== cookieSecret;
}

export function getCSRFToken() {
  if (typeof Globals !== 'undefined' && Globals?.csrf_token) {
    let token = Globals?.csrf_token;
    let cookie = jscookie.get('csrftoken');

    if (CSRFTokenIsStale(token)) {
      if (cookie === undefined) {
        cookie = generateNewCSRFToken();
        jscookie.set('csrftoken', cookie);
      }
      token = generateNewCSRFToken(cookie);
      Globals.csrf_token = token;
    }
    return token;
  }
  if (typeof window !== "undefined") {
    return jscookie.get('csrftoken');
  }
  return undefined;
}

export { getCSRFToken as default };
